import axios from 'axios';

async function createAddToCartButtonClickedEvent({ cartId, productId }) {
    await axios.post('/api/event/add-to-cart-button-clicked', {
        cartId,
        productId,
    });
}

export { createAddToCartButtonClickedEvent };
